import { handleError, normalize, normjoin } from "../utils/normalize";
import { ObjectTypes } from "./TorgaRouter";

function reducer(state, action) {
  try {
    const payload = action.payload;
    switch (action.type) {
      case 'ERROR': {
        return {
          ...state,
          errors: handleError(state.errors, payload, 'torga'),
        };
      }
      case 'CLEAR_ERRORS':
        return { ...state, errors: [] };
      case 'REFRESH_DATA':
        return { ...state, refreshKey: state.refreshKey + 1 };
      case 'FETCH_DATA':
        return state;

      case 'ACTIVITY_CHANGE': {
        let actChState = { ...state };
        const { [payload.id]: activity } = actChState.activities.byID;
        activity[payload.field] = payload.value;
        actChState.activities[payload.id] = activity;
        return actChState;
      }
      case 'FETCH_ACTIVITY_COMPLETE':
      case 'ACTIVITY_PERSIST_COMPLETED':
      case 'ACTIVITY_ADD_COMPLETE':
        return {
          ...state,
          activities: normalize(state.activities, action.payload, [
            { name: 'parentID', keys: ['parent_id'] },
          ]),
        };

      // ==== EQUIPMENTS  ====

      case 'EQUIPMENT_CHANGE': {
        const equChState = { ...state };
        equChState.equipments.byID[payload.id] = {
          ...equChState.equipments.byID[payload.id],
          [payload.field]: payload.value,
        };
        return equChState;
      }
      case 'EQUIPMENT_PERSIST_COMPLETE':
      case 'EQUIPMENT_FETCH_COMPLETE': {
        return {
          ...state,
          equipments: normalize(state.equipments, action.payload),
        };
      }

      // ==== ACTIVITYEQUIPMENTS ====

      case 'ACTIVITYEQUIPMENTS_FETCH_COMPLETE':
      case 'ACTIVITYEQUIPMENTS_REMOVE':
      case 'ACTIVITYEQUIPMENTS_ADD':
      case 'ACTIONITEMSTRIGGERS_REMOVE':
      case 'ACTIONITEMSTRIGGERS_ADD': {
        return normjoin(state, action.payload, {
          fields: ['activity_id', 'equipment_id'],
          objects: [ObjectTypes.ACTIVITIES, ObjectTypes.EQUIPMENTS],
          keys: ['activityID', 'equipmentID'],
        });
      }

      // ==== TRIPS ====

      case 'TRIP_FETCH_COMPLETE':
        return { ...state, trips: normalize(state.trips, action.payload) };

      case 'LOG_STATE':
        console.log(state);
        return state;

      // ==== DIARY POSTS ====

      case 'DIARYPOST_FETCH_COMPLETE':
      case 'DIARYPOST_CREATE_COMPLETE':
      case 'DIARYPOST_PERSIST_COMPLETE':
        return {
          ...state,
          diaryposts: normalize(state.diaryposts, action.payload),
        };

      // ===== ROUTINE ====

      case 'ROUTINE_FETCH_COMPLETE':
      case 'ROUTINE_ADD_COMPLETE':
      case 'ROUTINE_PERSIST_COMPLETE':
        return {
          ...state,
          routines: normalize(state.routines, action.payload),
        };

      case 'ROUTINE_CHANGE': {
        let actChState = { ...state };
        const { [payload.id]: routine } = actChState.routines.byID;
        routine[payload.field] = payload.value;
        actChState.routines[payload.id] = routine;
        return actChState;
      }

      // ==== ROUTINEACTIVITIES ====

      case 'ROUTINEACTIVITIES_FETCH_COMPLETE':
      case 'ROUTINEACTIVITIES_REMOVE':
      case 'ROUTINEACTIVITIES_ADD': {
        return normjoin(state, action.payload, {
          fields: ['routine_id', 'activity_id'],
          objects: [ObjectTypes.ROUTINE, ObjectTypes.ACTIVITIES],
          keys: ['routineID', 'activityID'],
        });
      }

      // ==== GOALS ====

      case 'GOAL_CHANGE': {
        let actChState = { ...state };
        const { [payload.id]: goal } = actChState.goals.byID;
        goal[payload.field] = payload.value;
        actChState.goals[payload.id] = goal;
        return actChState;
      }

      case 'GOAL_FETCH_ALL_COMPLETE':
      case 'GOAL_CREATE_COMPLETE':
      case 'GOAL_UPDATE_COMPLETE':
        return { ...state, goals: normalize(state.goals, action.payload) };

      // ==== TASKS ====

      case 'TASK_CHANGE': {
        let actChState = { ...state };
        const { [payload.id]: task } = actChState.tasks.byID;
        task[payload.field] = payload.value;
        actChState.tasks[payload.id] = task;
        return actChState;
      }

      case 'TASK_FETCH_ALL_COMPLETE':
      case 'TASK_CREATE_COMPLETE':
      case 'TASK_UPDATE_COMPLETE':
        return { ...state, tasks: normalize(state.tasks, action.payload) };

      // ==== GOALTASKS ====

      case 'GOALTASK_FETCH_ALL_COMPLETE':
      case 'GOALTASK_CREATE_COMPLETE':
      case 'GOALTASK_UPDATE_COMPLETE':
        return normjoin(state, action.payload, {
          fields: ['goal_id', 'task_id'],
          objects: [ObjectTypes.GOALS, ObjectTypes.TASKS],
          keys: ['goalID', 'taskID'],
        });

      // ==== ACTIVITY_GOAL ====

      case 'ACTIVITYGOAL_FETCH_ALL_COMPLETE':
      case 'ACTIVITYGOAL_CREATE_COMPLETE':
      case 'ACTIVITYGOAL_UPDATE_COMPLETE':
        return normjoin(state, action.payload, {
          fields: ['activity_id', 'goal_id'],
          objects: [ObjectTypes.ACTIVITIES, ObjectTypes.GOALS],
          keys: ['activityID', 'goalID'],
        });

      // ==== DEFAULT ====
      default:
        throw new Error(
          `[${action.type}] is unknown in Torga Reducer. Did you returned a new state ?`
        );
    }
  } catch (err) {
    console.error(err);
    return {
      ...state,
      errors: handleError(state.errors, err, "torga"),
    };
  }
}

export default reducer;
